var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
//Shopify.money_format = "${{amount}}";
Shopify.money_format = $("html").data("money_format").toString();
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

// Close countdown
jQuery(function ($) {
  $(".floating-countdown__close").on("click", function () {
    $(".floating-countdown").addClass("deactivated");
  });
});

// WAVELENGTH RADIO BUTTON JS
$("input[type=radio][name=pw-select-nm]").click(function () {
  var data_class = $(this).attr("id");
  $(".cus-pw-label").addClass("hidden");
  $(".pw-wl-content #" + data_class).removeClass("hidden");
});
// qty cheang in pgp page

$(document).on("click", ".quantity__button", function () {
  if ($(".platinumled-therapy-lights-biomax-racks-stands").length > 0) {
    var $_this = $(this); //$('.quantity__button');
    $_this.css("pointer-events", "none");
    var qty_val_custom = $(this)
      .closest(".custom_product_buy_box")
      .find(".quantity__input")
      .val();
    //var getPrice =  $(".remote_price").val();
    var getPrice = $(this)
      .closest(".product__info-container")
      .find(".product__price")
      .data("money_price");
    console.log("List =>", qty_val_custom, getPrice);
    getPrice = parseFloat(qty_val_custom) * parseFloat(getPrice);
    getPrice = Shopify.formatMoney(getPrice, Shopify.money_format);
    console.log("List =>", qty_val_custom, getPrice);
    $(this)
      .closest(".product__info-container")
      .find(".product__price")
      .text(getPrice);
    $_this.css("pointer-events", "all");
  } else {
    var $_this = $(this); //$('.quantity__button');
    $_this.css("pointer-events", "none");
    var qty_val_custom = $(this).parents().find(".quantity__input").val();
    //var getPrice =  $(".remote_price").val();
    var getPrice = $(".remote_price").data("money_price");
    console.log("1=>", qty_val_custom, getPrice);
    getPrice = parseFloat(qty_val_custom) * parseFloat(getPrice);
    console.log("2=>", qty_val_custom, getPrice);

    getPrice = Shopify.formatMoney(getPrice, Shopify.money_format);
    $(".price-item").text(getPrice);
    //$(this).closest('.product__price').text(getPrice);
    $_this.css("pointer-events", "all");
  }
});

// $(".quantity .quantity__input").bind("change paste keyup", function() {
//   var $_this = $('.quantity__button');
//   $_this.css('pointer-events','none');
//   var qty_val_custom = $(this).val();
//   if (qty_val_custom.length <= 0){
//     var qty_val_custom = 1;
//   }

//   var getPrice =  $(".remote_price").data('money_price');
//   console.log('1=>',qty_val_custom,getPrice);
//   getPrice = (parseFloat(qty_val_custom) * parseFloat(getPrice));
//   console.log('2=>',qty_val_custom,getPrice);

//   getPrice = Shopify.formatMoney(getPrice,Shopify.money_format);

//   $(".price-item").text(getPrice );
//   $_this.css('pointer-events','all');
// });

/// slider
if ($(".custom_slider_blog").length > 0) {
  $(".custom_slider_blog").slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    infinite: true,
    centerMode: true,
    centerPadding: "100px",
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerPadding: "70px",
        },
      },
    ],
  });
}

// .custom_slider_blog

function playVideo(id) {
  // event.preventDefault();
  //     var video_seletor =  $(id).get(0);
  //     if (video_seletor.paused) {
  //             video_seletor.play();
  //         } else {
  //             video_seletor.pause();
  //        }
}

$(document).on("click", "a[data_video_id]", function (event) {
  event.preventDefault();
  var video_seletor_id = $(this).attr("data_video_id");
  $(this).find("img").hide();
  var video_seletor = $(video_seletor_id).get(0);
  if (video_seletor.paused) {
    $(this).addClass("play_video");
    $(this).find("img.pause_icon").show();
    video_seletor.play();
  } else {
    $(this).removeClass("play_video");
    $(this).find("img.play_icon").show();
    video_seletor.pause();
  }
});

var slider = $(".custom_slider_blog");
slider.on("wheel", function (event) {
  // Detect the direction of scroll (up or down)
  var delta = event.originalEvent.deltaY;
  // Depending on the direction, navigate to the next or previous slide
  if (delta > 0) {
    // console.log('next');
    slider.slick("slickNext");
  } else {
    // console.log('prev');
    slider.slick("slickPrev");
  }
});

// Biolight pdp

$(".middle_text a").click(function () {
  $(".pargrapth_text").toggleClass("show_detail");
  $(".custom_btn.advanced_lights_main").toggleClass("show_detail");
});

//Icon With Text Section Slider For Home Page
// $("body.index .dd_icon_with_text .icon_with_text_main").slick({
//   dots: false,
//   arrows: false,
//   infinite: true,
//   cssEase: "linear",
//   // speed: 2000,
//   speed: 4000,
//   autoplay: true,
//   // autoplaySpeed: 2000,
//   autoplaySpeed: 0,
//   slidesToShow: 3,
//   slidesToScroll: 1,
//   responsive: [
//     {
//       breakpoint: 992,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 1,
//       },
//     },
//     {
//       breakpoint: 600,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1,
//       },
//     },
//     {
//       breakpoint: 480,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1,
//       },
//     },
//   ],
// });

if (!window.location.pathname.includes("/products/")) {
  $(".icon_with_text_main").slick({
    dots: false,
    arrows: false,
    infinite: true,
    cssEase: "linear",
    speed: 4000,
    autoplay: true,
    autoplaySpeed: 0,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
}

$(document).ready(function () {
  jQuery(".tab_heading_list_row .tab_list .tab_list_item").click(function (e) {
    e.preventDefault();
    e.stopPropagation();
    let _index = jQuery(this).index();
    console.log(_index);

    jQuery(".tab_heading_list_row .tab_list .tab_list_item").removeClass(
      "active"
    );
    jQuery(this).addClass("active");

    jQuery(
      `.tab_image_column.tab_image_left_column .tab_left_image img`
    ).removeClass("active");
    jQuery(`.test-result-wrapper img`).removeClass("active");
    jQuery(`.test-result-wrapper a`).removeClass("active");
    jQuery(
      `.tab_image_column.tab_image_left_column .left_inner_first_column .tab_left_image img:eq(${_index})`
    ).addClass("active");
    jQuery(
      `.tab_image_column.tab_image_left_column .left_inner_second_column .tab_left_image img:eq(${_index})`
    ).addClass("active");

    jQuery(
      `.tab_image_column.tab_image_left_column .tab_left_content h3`
    ).removeClass("active");
    jQuery(
      `.tab_image_column.tab_image_left_column .left_inner_first_column .tab_left_content h3:eq(${_index})`
    ).addClass("active");
    jQuery(
      `.tab_image_column.tab_image_left_column .left_inner_second_column .tab_left_content h3:eq(${_index})`
    ).addClass("active");
    jQuery(`.test-result-wrapper img:eq(${_index})`).addClass("active");
    jQuery(`.test-result-wrapper a:eq(${_index})`).addClass("active");

    jQuery(
      `.tab_image_column.tab_image_right_column .right_column_image img`
    ).removeClass("active");
    jQuery(
      `.tab_image_column.tab_image_right_column .right_column_image img:eq(${_index})`
    ).addClass("active");
  });

  jQuery(
    jQuery(".tab_heading_list_row .tab_list .tab_list_item").get(0)
  ).click();

  console.log("product-platinumled called");

  if ($(".saunamax-pro").length > 0) {
    // $('.line-item-property__field label').click(function(){
    //   $(this).closest('.line-item-property__field').toggleClass('active');
    // });
  }

  if ($(".platinumled-therapy-lights-biomax-series").length > 0 || $(".product-product-multi-lights").length > 0) {
    // ADD ONLY BIOMAX PRODUCTS WITH REMOTE PRODUCT TO ADD TO CART
    $(".product-1889061830722 .product-form__buttons").click(function (e) {
      console.log("product-1889061830722 clicked");

      if ($("#professional-touchscreen-remote-99").is(":checked")) {
        console.log("pp checked");
        e.preventDefault();
        var location_url = $(location).attr("href");
        var lastSegment = location_url.split("/").pop().split("=");
        var variant_id = lastSegment[1];
        const variant_quantity = $(".quantity__input").val();
        if (!variant_id) {
          variant_id = "15666979340354";
        }

        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: {
            items: [
              {
                id: 39840963788866,
                quantity: 1,
              },
              {
                id: variant_id,
                quantity: variant_quantity,
              },
            ],
          },
          dataType: "json",
          success: function (result, status, xhr) {
            console.log(result, "2345");
            window.location.href = "/cart";
          },
          error: function (xhr, status, error) {
            alert(
              "Result: " +
                status +
                " " +
                error +
                " " +
                xhr.status +
                " " +
                xhr.statusText
            );
          },
        });
      }
    });

    // on click of remote checkbox change image START
    var remotePrice = 0;
    $.ajax({
      url: "/products/biomax-professional-remote-control.json",
      type: "GET",
    }).done(function (data) {
      console.log("customjs_data => ", data);
      remotePrice = data.product.variants[0].price;
      remotePrice = remotePrice * 100;
      // var getPrice_remote =  $(".price-item").text();
      // getPrice_remote = $.trim(getPrice_remote);
      // var getCurrency = getPrice_remote.substring(0, 1);
      var getCurrency = $("html").data("curr_symbol");
      console.log("Global getCurrency 1 =>", getCurrency);
      console.log("Global remotePrice 1 =>", remotePrice);
      //$('.remote_text').text(getCurrency + parseFloat(remotePrice));

      $(".remote_text").attr("data-money_price", remotePrice);

      var remoteCurrPrice = Shopify.formatMoney(
        remotePrice,
        Shopify.money_format
      );
      $(".remote_text").text(remoteCurrPrice);
    });

    // $('.line-item-property__field').click(function (){
    //   console.log(this);
    //   $(this).toggleClass('active');
    //   remoteImage();
    // });
    $(document).on("click", ".line-item-property__field", function () {
      console.log("line-item-property__field=>", this);
      remoteImage(this);
    });

    $("input[type=radio]").each(function () {
      $(this).on("click", function () {
        if ($(this).val() == "BIOMAX 300") {
          if (
            $("#professional-touchscreen-remote-99").is(":checked") == false
          ) {
            removeRemotePrice();
            //$(".product__media>img").attr( "src", "https://cdn.shopify.com/s/files/1/0007/9711/4434/products/BIOMAX300_Front-v3_blueandredlightson_1_-optimized_1000x1000.jpg?v=1672239446" );
            $(".product__media>img").attr(
              "src",
              "https://cdn.shopify.com/s/files/1/0007/9711/4434/files/biomax-rlt_BIOMAX-300.png?v=1703072681"
            );
          } else if (
            $("#professional-touchscreen-remote-99").is(":checked") == true
          ) {
            AddRemotePrice();
            $(".product__media>img").attr(
              "src",
              "https://cdn.shopify.com/s/files/1/0007/9711/4434/files/biomax-300-with-remote_b9377076-9e4a-4bde-997d-386f5afbbd0f.png?v=1672847607"
            );
          }
        } else if ($(this).val() == "BIOMAX 450") {
          if (
            $("#professional-touchscreen-remote-99").is(":checked") == false
          ) {
            removeRemotePrice();
            //$(".product__media>img").attr( "src", "https://cdn.shopify.com/s/files/1/0007/9711/4434/products/BIOMAX450_Front-v3_blueandredlightson_1000x1000.jpg?v=1672239482" );
            $(".product__media>img").attr(
              "src",
              "https://cdn.shopify.com/s/files/1/0007/9711/4434/files/biomax-rlt_BIOMAX-450.png?v=1703072694"
            );
          } else if (
            $("#professional-touchscreen-remote-99").is(":checked") == true
          ) {
            AddRemotePrice();
            $(".product__media>img").attr(
              "src",
              "https://cdn.shopify.com/s/files/1/0007/9711/4434/files/biomax-450-with-remote_ef144a0a-d980-482f-9ec5-2ddc50106739.png?v=1672847607"
            );
          }
        } else if ($(this).val() == "BIOMAX 600") {
          if (
            $("#professional-touchscreen-remote-99").is(":checked") == false
          ) {
            removeRemotePrice();
            $(".product__media>img").attr(
              "src",
              "https://cdn.shopify.com/s/files/1/0007/9711/4434/files/biomax-rlt_BIOMAX-600.png?v=1703072707"
            );
          } else if (
            $("#professional-touchscreen-remote-99").is(":checked") == true
          ) {
            AddRemotePrice();
            $(".product__media>img").attr(
              "src",
              "https://cdn.shopify.com/s/files/1/0007/9711/4434/files/biomax-600-with-remote_bc69a346-fe8b-44d6-8373-1c5bc9cd2906.png?v=1672847606"
            );
          }
        } else if ($(this).val() == "BIOMAX 900") {
          if (
            $("#professional-touchscreen-remote-99").is(":checked") == false
          ) {
            removeRemotePrice();
            $(".product__media>img").attr(
              "src",
              "https://cdn.shopify.com/s/files/1/0007/9711/4434/files/biomax-rlt_BIOMAX-900.png?v=1703074019"
            );
          } else if (
            $("#professional-touchscreen-remote-99").is(":checked") == true
          ) {
            AddRemotePrice();
            $(".product__media>img").attr(
              "src",
              "https://cdn.shopify.com/s/files/1/0007/9711/4434/files/biomax-900-with-remote_d1d2f32c-a546-4dcc-b32f-bd8988985acf.png?v=1672847607"
            );
          }
        }
      });
    });

    function remoteImage(this_btn) {
      if ($("#professional-touchscreen-remote-99").is(":checked") == true) {
        $(this_btn).addClass("active");
        $(".line-item-property__field").addClass("active");
      } else {
        $(this_btn).removeClass("active");
        $(".line-item-property__field").removeClass("active");
      }

      if (
        $("#professional-touchscreen-remote-99").is(":checked") == true &&
        $("input[type=radio]:checked").val() == "BIOMAX 300"
      ) {
        $(".product__media>img").attr(
          "src",
          "https://cdn.shopify.com/s/files/1/0007/9711/4434/files/biomax-300-with-remote_b9377076-9e4a-4bde-997d-386f5afbbd0f.png?v=1672847607"
        );
        AddRemotePrice();
      } else if (
        $("#professional-touchscreen-remote-99").is(":checked") == false &&
        $("input[type=radio]:checked").val() == "BIOMAX 300"
      ) {
        //$(".product__media>img").attr("src", "https://cdn.shopify.com/s/files/1/0007/9711/4434/products/BIOMAX300_Front-v3_blueandredlightson_1_-optimized_1000x1000.jpg?v=1672239446");
        $(".product__media>img").attr(
          "src",
          "https://cdn.shopify.com/s/files/1/0007/9711/4434/files/biomax-rlt_BIOMAX-300.png?v=1703072681"
        );
        removeRemotePrice();
      } else if (
        $("#professional-touchscreen-remote-99").is(":checked") == true &&
        $("input[type=radio]:checked").val() == "BIOMAX 450"
      ) {
        $(".product__media>img").attr(
          "src",
          "https://cdn.shopify.com/s/files/1/0007/9711/4434/files/biomax-450-with-remote_ef144a0a-d980-482f-9ec5-2ddc50106739.png?v=1672847607"
        );
        AddRemotePrice();
      } else if (
        $("#professional-touchscreen-remote-99").is(":checked") == false &&
        $("input[type=radio]:checked").val() == "BIOMAX 450"
      ) {
        //$(".product__media>img").attr("src", "https://cdn.shopify.com/s/files/1/0007/9711/4434/products/BIOMAX450_Front-v3_blueandredlightson_1000x1000.jpg?v=1672239482");
        $(".product__media>img").attr(
          "src",
          "https://cdn.shopify.com/s/files/1/0007/9711/4434/files/biomax-rlt_BIOMAX-450.png?v=1703072694"
        );

        removeRemotePrice();
      } else if (
        $("#professional-touchscreen-remote-99").is(":checked") == true &&
        $("input[type=radio]:checked").val() == "BIOMAX 600"
      ) {
        $(".product__media>img").attr(
          "src",
          "https://cdn.shopify.com/s/files/1/0007/9711/4434/files/biomax-600-with-remote_bc69a346-fe8b-44d6-8373-1c5bc9cd2906.png?v=1672847606"
        );
        AddRemotePrice();
      } else if (
        $("#professional-touchscreen-remote-99").is(":checked") == false &&
        $("input[type=radio]:checked").val() == "BIOMAX 600"
      ) {
        $(".product__media>img").attr(
          "src",
          "https://cdn.shopify.com/s/files/1/0007/9711/4434/files/biomax-rlt_BIOMAX-600.png?v=1703072707"
        );
        removeRemotePrice();
      } else if (
        $("#professional-touchscreen-remote-99").is(":checked") == true &&
        $("input[type=radio]:checked").val() == "BIOMAX 900"
      ) {
        $(".product__media>img").attr(
          "src",
          "https://cdn.shopify.com/s/files/1/0007/9711/4434/files/biomax-900-with-remote_d1d2f32c-a546-4dcc-b32f-bd8988985acf.png?v=1672847607"
        );
        AddRemotePrice();
      } else if (
        $("#professional-touchscreen-remote-99").is(":checked") == false &&
        $("input[type=radio]:checked").val() == "BIOMAX 900"
      ) {
        $(".product__media>img").attr(
          "src",
          "https://cdn.shopify.com/s/files/1/0007/9711/4434/files/biomax-rlt_BIOMAX-900.png?v=1703074019"
        );
        removeRemotePrice();
      }
      console.log("remoteImage-this_btn");
    }

    remoteImage();

    // add remote price
    function AddRemotePrice() {
      setTimeout(() => {
        var qty = parseInt($(".quantity__input").val());
        var getPrice = $(".remote_price").data("money_price") * qty;
        console.log("else remotePrice 11 2 =>", remotePrice);

        getPrice = parseFloat(remotePrice) + parseFloat(getPrice);
        console.log("else getPrice 2 =>", getPrice);

        var getCurrency = $("html").data("curr_symbol");
        console.log("else getCurrency 2=>", getCurrency);

        $(".price-item").text(
          Shopify.formatMoney(getPrice, Shopify.money_format)
        );
        $(".remote_text").text(
          Shopify.formatMoney(remotePrice, Shopify.money_format)
        );
      }, "900");
    }

    //remove remote Price
    function removeRemotePrice() {
      setTimeout(() => {
        var qty = parseInt($(".quantity__input").val());
        //var getPrice = $(".remote_price").val();
        var getPrice = $(".remote_price").data("money_price") * qty;
        getPrice = Shopify.formatMoney(getPrice, Shopify.money_format);
        $(".price-item").text(getPrice);
      }, "900");
    }
  }

  if ($(".page-how-it-work").length > 0) {
    $(".butt_video").click(function (e) {
      var $this = $(this);
      // console.log('1111');
      e.preventDefault();
      if ($this.hasClass("paused")) {
        $(".video_inner").find("video").trigger("play");
        $this.removeClass("paused");
      } else {
        $(".video_inner").find("video").trigger("pause");
        $this.addClass("paused");
      }
    });
  }
});

// top scroll js
$(function () {
  // This will select everything with the class smoothScroll
  // This should prevent problems with carousel, scrollspy, etc...
  $(".smoothScroll").click(function () {
    if (
      location.pathname.replace(/^\//, "") ==
        this.pathname.replace(/^\//, "") &&
      location.hostname == this.hostname
    ) {
      var target = $(this.hash);
      target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
      if (target.length) {
        var distancetocover = Math.abs(
          $(document).scrollTop() - target.offset().top
        );
        var minTimeToScroll = 500,
          maxTimeToScroll = 1500;
        var timetoscroll = distancetocover / 5;
        timetoscroll =
          timetoscroll < minTimeToScroll ? minTimeToScroll : timetoscroll;
        timetoscroll =
          timetoscroll > maxTimeToScroll ? maxTimeToScroll : timetoscroll;
        $("html,body").animate(
          {
            scrollTop: target.offset().top,
          },
          timetoscroll
        ); // The number here represents the speed of the scroll in milliseconds
        return false;
      }
    }
  });
});
// top scroll js

/* ***Code is in review-section file with app code*** */
/*
$(document).ready(function(){  
  var isALARendered;
  function ALAcheck() {
    isALARendered = setInterval(function () {
      customALA()
    }, 1000);
  }
  ALAcheck();
  function customALA() {
    var $selector = $('.ElementsWidget__inner').length;
    if( $selector > 0) {
      clearInterval(isALARendered);
  
      //Your code.

      $('.R-ContentList__item').each(function(i,e){
        console.log('i',i);
        console.log('e',e);
        var $this = $(this);
        $this.find('.R-RatingStars.R-RatingStars--sm').html('');
        $this.find('.R-BadgeElement__icon').appendTo( $this.find('.item__review .R-RatingStars.R-RatingStars--sm') );
        $this.find('.cssVar-authorName.c-meta__authorName').appendTo( $this.find('.item__review .R-RatingStars.R-RatingStars--sm') );
        $this.find('.c-meta__authorLocation').prependTo( $this.find('.item__review .R-flex-row.R-flex-row--noMargin > .u-marginBottom--sm').first() );
        $this.find('.item__meta').hide();
        
      });
      // $('.R-RatingStars.R-RatingStars--sm').html('');
      // //$('.R-BadgeElement__icon').prependTo( $('.item__review .R-TextHeading.R-TextHeading--xxs') );
      // $('.R-BadgeElement__icon').appendTo( $('.item__review .R-RatingStars.R-RatingStars--sm') );
      // $('.cssVar-authorName.c-meta__authorName').appendTo( $('.item__review .R-RatingStars.R-RatingStars--sm') );
      // $('.c-meta__authorLocation').prependTo( $('.item__review .R-flex-row.R-flex-row--noMargin > .u-marginBottom--sm').first() );
      // $('.item__meta').hide();
      
  
    }
  }  
});
*/
